import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router';

import { useActions } from '@shared/lib/hooks/useActions';
import { isUUID } from '@shared/lib/validation';

export const CompanyContextLayout = () => {
	const { companyId } = useParams();
	const { activateCompanyContext } = useActions();

	useEffect(() => {
		if (companyId) {
			activateCompanyContext(companyId);
		}
	}, [companyId]);

	if (!isUUID(companyId)) return <Navigate to='/' replace />;

	return <Outlet />;
};
